module.exports = __webpack_public_path__ + "media/Video 112.269a1edc.mp4";